module.exports = __webpack_public_path__ + "img/geotrust.4a01fe07.png";